
<div class="view-component">
    <div class="view-component-body">
        <div class="card">
            <div class="card-header">{{'system.cache.title'|translateTA}}</div>
            <div class="card-content">
                <div class="central">
                    <button type="button" nz-button nzType="primary" (click)="descartarCache()"
                        nz-tooltip [nzTooltipTitle]="'system.cache.title'|translateTA">
                        {{'system.execute'|translateTA}}
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header">{{'system.pref.title'|translateTA}}</div>
            <div class="card-content">
                <div class="central">
                    <button type="button" nz-button nzType="primary" (click)="reloadPreferencia()"
                        nz-tooltip [nzTooltipTitle]="'system.pref.title'|translateTA">
                        {{'system.execute'|translateTA}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
